/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../locales/en-US/descriptors';
import './AllUtilitiesSavingsByMeterDetailComponent.scss';
import { UtilityMeterField } from '../../shared/Utils/Constants';
import { IDataTableColumn } from '../../shared/MeterSavingsDetailTable/IMeterSavingsDetailTableProps';
import UtilityCostDetailTabBreakdownBySite from '../../shared/DetailBreakdownByMeter/UtilityCostDetailTabBreakdownBySite';
import { convertDataForAllUtilityCostSavingsSite } from '../../shared/Utils/UtilityViewDetails';
import { IUtilityCostAllData } from '../UtilityBillViewDetailsComponent/IUtilityBillViewDetails';
import { ApiContext } from '../../../context/ApiContext';

interface IAllUtilitiesSavingsBySiteDetailComponentProps {
  data: IUtilityCostAllData;
}

export const AllUtilitiesSavingsBySiteDetailComponent = (
  props: IAllUtilitiesSavingsBySiteDetailComponentProps
) => {
  const [t] = useTranslation();
  const d = descriptors.DetailedView;
  const { data } = props;

  const apiContext = useContext(ApiContext);

  const { utilityCostCurrency, breakdownBySite } = data;

  const siteSavingData = convertDataForAllUtilityCostSavingsSite(
    breakdownBySite,
    apiContext.showChangeWhenData
  );
  const columnDetails: IDataTableColumn[] = [
    {
      className: 'datatable-column-meter',
      field: UtilityMeterField.siteName,
      header: t(d.SITES),
      sortable: true,
      initialWidth: '10%'
    },
    {
      className: 'datatable-column-actualConsumption',
      field: UtilityMeterField.totalActualCost,
      header: t(d.PORTFOLIOACTUALCOST),
      sortable: true,
      initialWidth: '20%'
    },
    {
      className: 'datatable-column-baselineConsumption',
      field: UtilityMeterField.previousPeriodCost,
      header: t(d.PORTFOLIOPREVIOUSCOST),
      sortable: true,
      initialWidth: '9%'
    },
    {
      className: 'datatable-column-change',
      field: UtilityMeterField.costSavings,
      header: t(d.CHANGE),
      sortable: true,
      initialWidth: '9%'
    }
  ];

  return (
    <div className="emaas-Metersaving-details-head">
      <UtilityCostDetailTabBreakdownBySite
        siteData={siteSavingData}
        utilityCostCurrency={utilityCostCurrency}
        columnDetails={columnDetails}
      />
    </div>
  );
};
export default AllUtilitiesSavingsBySiteDetailComponent;
